import React, { useContext } from "react";
import { FaUser, FaCopyright, FaAdjust, FaBuilding, FaCloudMoonRain, FaGlobe } from "react-icons/fa";
import { Context } from "./contexts/AppContext";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AccountInfo = () => {

    const { value } = useContext(Context);
  const [appState, setAppState] = value; 
    const navigate = useNavigate();
  return (
    <div className="absolute top-8 right-4 z-50 bg-white shadow-lg rounded-lg w-96">
      {/* User Info */}
      <div className="flex items-center p-4 border-b text-black">
        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gray-800 text-white rounded-full text-lg font-bold">
             <FontAwesomeIcon icon="fa-solid fa-user" />
        </div>
        <div className="ml-4">
          <div className="text-lg font-semibold text-gray-800">{appState?.adminDetails?.name}</div>
          <div className="text-sm text-gray-500">{appState?.adminDetails?.email}</div>
        </div>
        {appState?.adminDetails?.plan!=="imageonly" && (  <button
          className="ml-auto px-2 py-1 text-sm border border-gray-400 rounded hover:bg-gray-100"
          title="Your Data Balance"
        >
          <span className="mr-1">©</span> {(() => {
    const creditsMB = appState?.adminDetails?.credits || 0; // available size in MB
    const availableGB = creditsMB / 1024;
    const availableKB = creditsMB * 1024;

    // 1 credit = 5 GB
    const credits = availableGB / 5;

    // Auto-detect storage unit
    let sizeValue, sizeUnit;
    if (availableGB >= 1) {
      sizeValue = availableGB.toFixed(2);
      sizeUnit = "GB";
    } else if (creditsMB >= 1) {
      sizeValue = creditsMB.toFixed(2);
      sizeUnit = "MB";
    } else {
      sizeValue = availableKB.toFixed(2);
      sizeUnit = "KB";
    }

    return ` ${sizeValue} ${sizeUnit}`;
  })()}
        </button>)}
      
      </div>

      {/* Menu Items */}
      <ul className="divide-y text-black">
        <li>
          <Link to="/studio/account/accountsetting">
          <button className="w-full flex items-center px-4 py-3 text-left hover:bg-gray-100">
            <FaUser className="text-gray-800 mr-2" /> Account Settings
          </button>
          </Link>
        </li>
         <li>
          <Link to="/studio/account/companysetting">
          <button className="w-full flex items-center px-4 py-3 text-left hover:bg-gray-100">
            <FaBuilding className="text-gray-800 mr-2" /> Company Settings
          </button>
          </Link>
        </li>

         <li>
          <Link to="/studio/account/domainsetting">
          <button className="w-full flex items-center px-4 py-3 text-left hover:bg-gray-100">
            <FaGlobe className="text-gray-800 mr-2" /> Domain Setting
          </button>
          </Link>
        </li>
         <li>
        <Link to="/studio/account/planbill">
          <button className="w-full flex items-center px-4 py-3 text-left hover:bg-gray-100">
            <FaCopyright className="text-gray-800 mr-2" /> Plans & Billing
          </button>
          </Link>
        </li>
     {/*
        <li>
        <Link to="/studio/account/creditusage">
          <button className="w-full flex items-center px-4 py-3 text-left hover:bg-gray-100">
            <FaAdjust className="text-gray-800 mr-2" /> Data Usage
          </button>
          </Link>
        </li>  */}
      </ul>

      {/* Logout */}localStorage.removeItem("authToken");
      <div className="border-t">
        
    <button
  onClick={() => {
    localStorage.removeItem("authToken"); 
    navigate("/login");
  }}
  className="w-full text-left text-red-600 px-4 py-3 hover:bg-red-50 font-semibold"
>
  LOG OUT
</button>
        
      </div>
    </div>
  );
};

export default AccountInfo;
